export default {
  // 获取订单列表数据
  getOrders: {
    method: 'get',
    url: 'platform/trades'
  },
  // 获取订单详情数据
  orderDetail: {
    method: 'get',
    url: 'sys/orders/{id}'
  }
}
